var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddEmploye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_53",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3133",
    "data-name": "Rectangle 3133",
    width: 35.206,
    height: 35.216,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9149",
    "data-name": "Group 9149",
    transform: "translate(9.42 6.054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.42, -6.05)",
    filter: "url(#Ellipse_53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53-2",
    "data-name": "Ellipse 53",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11224",
    "data-name": "Group 11224",
    transform: "translate(25.58 25.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9238",
    "data-name": "Group 9238",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M13.792,198.408q-4.855,0-9.71,0a4.054,4.054,0,0,1-2.514-.748,3.778,3.778,0,0,1-1.545-2.673,4.508,4.508,0,0,1,.419-2.23,16.265,16.265,0,0,1,5.376-7.142,15.279,15.279,0,0,1,4.611-2.44,17.9,17.9,0,0,1,4.011-.811,16.642,16.642,0,0,1,7.488,1.107,15.92,15.92,0,0,1,2.526,1.259,1.256,1.256,0,0,1-.389,2.372,1.212,1.212,0,0,1-.86-.2,15.626,15.626,0,0,0-3.561-1.527,13.983,13.983,0,0,0-5.151-.491,13.772,13.772,0,0,0-8.075,3.537,13.423,13.423,0,0,0-2.537,3.059A13.755,13.755,0,0,0,2.649,194.1,1.223,1.223,0,0,0,3.7,195.869a3.836,3.836,0,0,0,.509.027q9.739,0,19.479,0a2.145,2.145,0,0,1,.637.09,1.208,1.208,0,0,1,.822,1.267,1.3,1.3,0,0,1-1.024,1.106,2.3,2.3,0,0,1-.448.042q-4.943,0-9.887,0",
    transform: "translate(0 -163.193)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M75.686,17.588a8.794,8.794,0,1,1,8.724-8.482,8.822,8.822,0,0,1-8.724,8.482m-.084-2.51a6.279,6.279,0,1,0-6.277-6.3,6.255,6.255,0,0,0,6.277,6.3",
    transform: "translate(-59.813 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M223.824,221.284h.256c1.088,0,2.176,0,3.263,0a2.524,2.524,0,0,1,.543.065,1.263,1.263,0,0,1,.971,1.207,1.281,1.281,0,0,1-1.068,1.17,3.605,3.605,0,0,1-.527.04c-1.055,0-2.11,0-3.165,0h-.272V224c0,1.127,0,2.254,0,3.381a1.339,1.339,0,0,1-.54,1.163,1.211,1.211,0,0,1-1.9-.849,6.427,6.427,0,0,1-.038-.684c0-1,0-1.992,0-2.988v-.258h-.249c-1.088,0-2.176,0-3.263,0a2.588,2.588,0,0,1-.562-.068,1.2,1.2,0,0,1-.928-1.263,1.217,1.217,0,0,1,1.066-1.112,5.649,5.649,0,0,1,.626-.038c1.016,0,2.031,0,3.047,0h.263v-.243c0-1.134,0-2.267,0-3.4a1.321,1.321,0,0,1,.424-1.04,1.156,1.156,0,0,1,1.242-.236,1.116,1.116,0,0,1,.774,1c.041.593.036,1.19.042,1.785.006.7,0,1.4,0,2.138",
    transform: "translate(-193.652 -193.6)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmploye);
export default __webpack_public_path__ + "static/media/add-employe.07d3a986227e6fb6597bbc09fc4b9502.svg";
export { ForwardRef as ReactComponent };